module.exports = __webpack_public_path__ + "img/2.f54fc9b8.png";